import { render } from "./Docker.vue?vue&type=template&id=0baed297"
import script from "./Docker.vue?vue&type=script&lang=js"
export * from "./Docker.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__